import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./GestisciFiera.css";

function GestisciFiera() {
    const [fiere, setFiere] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    // Carica fiere dal server
    useEffect(() => {
        const fetchFiere = async () => {
            try {
                const response = await fetch("/api/fiere");   // 🔥 CORRETTO

                const data = await response.json();

                if (data.success) {
                    setFiere(data.fiere);
                } else {
                    setError("Errore nel caricamento delle fiere");
                }
            } catch {
                setError("Errore di connessione al server");
            } finally {
                setLoading(false);
            }
        };

        fetchFiere();
    }, []);

    const handleGoHome = () => {
        navigate("/home");
    };

    // Elimina fiera
    const eliminaFiera = async (id) => {
        try {
            const response = await fetch(`/api/fiera/${id}`, {
                method: "DELETE",
            });

            const data = await response.json();

            if (data.success) {
                setFiere(prev => prev.filter(f => f._id !== id));
            }
        } catch (err) {
            console.error("Errore eliminazione:", err);
        }
    };

    // Raggruppa fiere per città
    const fierePerCitta = fiere.reduce((acc, fiera) => {
        if (!fiera.luogo) return acc;

        let citta = fiera.luogo
            .trim()
            .toLowerCase()
            .replace(/\s+/g, " ")
            .replace(/[^a-zàèéìòù\s]/gi, "");

        citta = citta.charAt(0).toUpperCase() + citta.slice(1);

        if (!acc[citta]) acc[citta] = [];
        acc[citta].push(fiera);

        return acc;
    }, {});

    return (
        <div id="container">
            {/* Navbar */}
            <div id="nav_bar">
                <div id="logo_container">
                    <img id="logo_title" src={"logo-header.png"} alt="Logo" />
                </div>

                <div id="title">
                    <p>Gestisci Fiere</p>
                </div>

                <div id="logout_button">
                    <button id="logout" onClick={handleGoHome}>Torna indietro</button>
                </div>
            </div>

            {/* Contenuto */}
            <div id="fiere_container">
                {loading && <p className="loading">Caricamento...</p>}
                {error && <p id="errore_text">{error}</p>}

                {!loading && !error && Object.keys(fierePerCitta).length === 0 && (
                    <p className="no_fiere">Nessuna fiera trovata</p>
                )}

                {Object.keys(fierePerCitta).map((citta) => (
                    <div key={citta} className="citta_section">
                        <h2 className="citta_titolo">{citta}</h2>

                        <div className="fiere_grid">
                            {fierePerCitta[citta].map((fiera) => (
                                <div className={`fiera_card ${fiera.chiusa ? "fiera_chiusa" : ""}`} key={fiera._id}>

                                    <div className="delete_btn" onClick={() => eliminaFiera(fiera._id)}>×</div>

                                    <h3 className="fiera_nome">{fiera.titolo}</h3>

                                    <div className="fiera_info">
                                        <p><strong>Luogo:</strong> {fiera.luogo}</p>
                                        <p><strong>Data:</strong> {fiera.data}</p>
                                    </div>

                                    <button
                                        className={`fiera_btn ${fiera.chiusa ? "btn_disabled" : ""}`}
                                        disabled={fiera.chiusa}
                                        onClick={() => !fiera.chiusa && navigate(`/fiera/${fiera._id}`)}
                                    >
                                        Fiera!
                                    </button>

                                </div>

                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default GestisciFiera;
